import styled from 'styled-components'
import { typoLabel } from '../../../lib/styles/Typography'
import { baseTransition } from '../../../lib/styles/Style'

export const StyledTooltip = styled.div<{ $noWrap?: boolean }>`
  display: none;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.black[1]};
  border: 1px solid ${({ theme }) => theme.colors.black[1]};
  padding: 0.4rem 0.6rem;
  border-radius: 0.4rem;
  z-index: 100;
  top: -0.4rem;
  left: 50%;
  transform-origin: bottom center;
  transform: translateX(-50%) translateY(-100%);
  color: white;
  flex-direction: column;
  gap: 0.3rem;
  align-items: center;
  min-width: 6rem;
  box-shadow: ${({ theme }) => theme.shadows.menuOpen};
  white-space: ${({ $noWrap }) => ($noWrap ? 'nowrap' : 'normal')};
  opacity: 0;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 0.3rem solid transparent;
    border-top-color: ${({ theme }) => theme.colors.black[1]};
    border-bottom: 0;
    margin-left: -0.3rem;
    margin-bottom: -0.3rem;
  }
`

export const StyledTooltipContainer = styled.div`
  display: flex;
  cursor: pointer;
  position: relative;

  &:hover ${StyledTooltip} {
    transition-property: opacity;
    ${baseTransition};
    display: flex;
    opacity: 1;
  }
`
export const StyledTooltipTitle = styled.span`
  ${typoLabel};
  margin-inline: auto;
  color: ${({ theme }) => theme.colors.electricIndigo[5]};
  white-space: nowrap;
`
